function tooltip() {
	const imageTextLink = document.querySelectorAll('.image-texte-link');
	
	imageTextLink.length && imageTextLink.forEach(container => {
		if (!container) return;
		
		const btn = container.querySelector('.product-home__button');
		const description = container.querySelector('.product-home__description');
		
		if (!btn || !description) return;
		
		const activateTooltip = () => {
			description.classList.add('active')
		}
		
		const deactivateTooltip = () => {
			description.classList.remove('active');
		}
		
		btn.addEventListener('mouseenter', activateTooltip);
		description.addEventListener('mouseleave', deactivateTooltip);
		container.addEventListener('mouseleave', deactivateTooltip);
	})
}

document.addEventListener('DOMContentLoaded', function () {
	tooltip();
	
	const imagesContainer = document.querySelector('.product-page__images');
	const buttons = document.querySelectorAll('.product-page__contenance-item');
	
	// Sécurité : si pas de container → on stoppe le script
	if (!imagesContainer) return;
	
	const images = imagesContainer.querySelectorAll('.product-page__image');
	
	// Fonction pour mettre à jour la classe number-product-X
	function updateNumberClass() {
		// Nettoyage des anciennes classes
		imagesContainer.classList.forEach(cls => {
			if (cls.startsWith('number-product-')) {
				imagesContainer.classList.remove(cls);
			}
		});
		
		const visibleImages = imagesContainer.querySelectorAll('.product-page__image:not(.disable)');
		imagesContainer.classList.add(`number-product-${visibleImages.length}`);
	}
	
	// Fonction pour mettre à jour l'affichage des images selon les boutons actifs
	function updateImages() {
		const activeButtons = Array.from(buttons).filter(btn => btn.classList.contains('active'));
		
		if (activeButtons.length === 0) {
			images.forEach(img => img.classList.remove('disable'));
		} else {
			images.forEach(img => img.classList.add('disable'));
			activeButtons.forEach(btn => {
				const imageId = btn.dataset.image;
				const img = document.getElementById(imageId);
				if (img) img.classList.remove('disable');
			});
		}
		updateNumberClass();
	}
	
	// Initialisation
	images.forEach(img => img.classList.remove('disable'));
	updateNumberClass();
	
	// Gestion clics
	buttons.forEach(button => {
		button.addEventListener('click', function () {
			button.classList.toggle('active');
			updateImages();
		});
	});
});